import * as React from 'react'

interface BreadcrumbProps {
  item: any
  onClick: (item) => void
}

interface BreadcrumbState {

}

class Breadcrumb extends React.Component<BreadcrumbProps, BreadcrumbState> {
  handleBreadcrumbClick = (e: React.MouseEvent<HTMLLIElement>) => {
    this.props.onClick(this.props.item)
  }

  handleBreadcrumbKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.props.onClick(this.props.item)
    }
  }

  render () {
    return (
      <li
        onClick={this.handleBreadcrumbClick}
        role='link'
        tabIndex={0}
        onKeyDown={this.handleBreadcrumbKeyDown}
      >{this.props.item.label}

      </li>
    )
  }
}

export {
  Breadcrumb
}
